import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {Clipboard} from '@angular/cdk/clipboard';
import {SharedModule} from '../../../../shared/shared.module';

@Component({
  selector: 'app-tmt-erp-outbound-raw-message-dialog',
  imports: [MatButton, MatIcon, MatTooltip, SharedModule],
  template: `
    <modal-panel [title]="data.title" (close)="dialogRef.close()">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
        <button mat-stroked-button (click)="copy()" matTooltip="Copy to clipboard">
          <mat-icon>content_copy</mat-icon>
          Copy
        </button>
      </div>
      <textarea
        readonly
        [value]="formattedContent"
        style="width: 100%; height: 480px; font-family: monospace; font-size: 12px; resize: vertical; box-sizing: border-box; padding: 8px;">
      </textarea>
      <ng-container modalPanelFooter>
        <button mat-button (click)="dialogRef.close()">Close</button>
      </ng-container>
    </modal-panel>
  `,
})
export class TmtErpOutboundRawMessageDialogComponent {
  protected readonly data = inject<{title: string; content: string}>(MAT_DIALOG_DATA);
  protected readonly dialogRef = inject(MatDialogRef<TmtErpOutboundRawMessageDialogComponent>);
  private readonly clipboard = inject(Clipboard);

  protected readonly formattedContent = this.prettyPrint(this.data.content);

  protected copy(): void {
    this.clipboard.copy(this.formattedContent);
  }

  private prettyPrint(content: string): string {
    if (!content) return '';
    try {
      return JSON.stringify(JSON.parse(content), null, 2);
    } catch {
      return content;
    }
  }
}
